(function () {
  class DegressivePrice extends HTMLElement {

    connectedCallback() {
      this._price = parseInt(this.dataset.price, 10);
      this._discounts = JSON.parse(this.dataset.discounts || '[]');
      // le barème vient du metafield custom.degressive_discounts : on garantit l'ordre décroissant attendu par _getRate
      this._discounts.sort(function (a, b) {
        return (parseInt(b.minQty, 10) || 0) - (parseInt(a.minQty, 10) || 0);
      });
      this._quantityInputSelector = this.dataset.qtyInput || null;
      this._updateTargetsSelector = this.dataset.updateTargets || null;
      this._updateSubscriptionTargetsSelector = this.dataset.subscriptionTargets || null;
      this._subPerUnitTargetsSelector = this.dataset.subPerUnitTargets || null;
      this._perUnitTargetsSelector = this.dataset.perUnitTargets || null;
      this._unitDivisor = parseInt(this.dataset.unitDivisor, 10) || 1;
      this._curePriceTargetSelector = this.dataset.curePriceTarget || null;
      this._curePopupMode = this.hasAttribute('data-cure-popup');

      if (this._curePopupMode) {
        this._crossSellIncreaseHandler = this._correctGlobalPrice.bind(this, 'increase');
        this._crossSellDecreaseHandler = this._correctGlobalPrice.bind(this, 'decrease');
        document.addEventListener('cross-sell:increase', this._crossSellIncreaseHandler);
        document.addEventListener('cross-sell:decrease', this._crossSellDecreaseHandler);
      } else {
        var quantity = this._getQuantity();
        if (!this.hasAttribute('hidden')) this._render(quantity);
        if (this._updateTargetsSelector) this._updateTargets(quantity);
        if (this._updateSubscriptionTargetsSelector) this._updateSubscriptionTargets(quantity);

        this._clickHandler = function (e) {
          if (e.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]')) {
            requestAnimationFrame(function () {
              var quantity = this._getQuantity();
              if (!this.hasAttribute('hidden')) this._render(quantity);
              if (this._updateTargetsSelector) this._updateTargets(quantity);
              if (this._updateSubscriptionTargetsSelector) this._updateSubscriptionTargets(quantity);
            }.bind(this));
          }
        }.bind(this);

        document.addEventListener('click', this._clickHandler);
      }
    }

    disconnectedCallback() {
      if (this._curePopupMode) {
        document.removeEventListener('cross-sell:increase', this._crossSellIncreaseHandler);
        document.removeEventListener('cross-sell:decrease', this._crossSellDecreaseHandler);
      } else {
        document.removeEventListener('click', this._clickHandler);
      }
    }

    _correctGlobalPrice(direction, event) {
      var curePopup = event.target.closest('cure-popup');

      if (!curePopup) return;
      if (!curePopup.contains(this)) return;

      var productScope = this.closest('.cure-popup__product');
      if (productScope && !productScope.contains(event.target)) return;

      var quantityInput = this._quantityInputSelector ? curePopup.querySelector(this._quantityInputSelector) : null;

      if (!quantityInput) return;

      var newQuantity = parseInt(quantityInput.value, 10) || 0;
      var oldQuantity = direction === 'increase' ? newQuantity - 1 : newQuantity + 1;
      var unitPriceEuros = this._price / 100;
      var newTotal = newQuantity * unitPriceEuros * (1 - this._getRate(newQuantity));
      var oldTotal = oldQuantity * unitPriceEuros * (1 - this._getRate(oldQuantity));
      var correction = direction === 'increase' ? (newTotal - oldTotal) - unitPriceEuros : (newTotal - oldTotal) + unitPriceEuros;

      curePopup.globalPrice = parseFloat((curePopup.globalPrice + correction).toFixed(2));

      if (this._curePriceTargetSelector) {
        var productInfo = this.closest('.cure-popup__product-info');
        if (productInfo) {
          var priceSpan = productInfo.querySelector(this._curePriceTargetSelector);
          if (priceSpan) {
            var rate = this._getRate(newQuantity);
            var prevDiscounted = priceSpan.parentNode.querySelector('.dp-cure-discounted');
            if (prevDiscounted) prevDiscounted.remove();
            if (rate > 0) {
              priceSpan.className = 'dp-cure-price primary text-subdued line-through';
              priceSpan.textContent = this._format(this._price);
              var discountedSpan = document.createElement('span');
              discountedSpan.className = 'dp-cure-discounted red';
              discountedSpan.textContent = this._format(Math.round(this._price * (1 - rate)));
              priceSpan.parentNode.insertBefore(discountedSpan, priceSpan);
            } else {
              priceSpan.className = 'dp-cure-price';
              priceSpan.textContent = this._format(this._price);
            }
          }
        }
      }
    }

    _updateSubscriptionTargets(quantity) {
      var effectiveQuantity = Math.max(quantity, 1);
      var tieredRate = this._getRate(effectiveQuantity);
      var scope = this.closest('[data-section-type]') || document;
      var spans = scope.querySelectorAll(this._updateSubscriptionTargetsSelector);

      spans.forEach((span) => {
        var prevBarred = span.parentNode.querySelector('.dp-sub-regular-price');
        if (prevBarred) prevBarred.remove();
        var subscriptionUnitPrice = parseInt(span.getAttribute('data-price'), 10);
        if (!subscriptionUnitPrice) return;

        var fullTotal = this._price * effectiveQuantity;
        var subscriptionTotal = Math.round(subscriptionUnitPrice * (1 - tieredRate)) * effectiveQuantity;

        var strikeSpan = document.createElement('span');
        strikeSpan.className = 'regular-price dp-sub-regular-price';
        strikeSpan.textContent = this._format(fullTotal);
        span.parentNode.insertBefore(strikeSpan, span);

        span.classList.add('sale-price');
        span.innerHTML = ' ' + this._format(subscriptionTotal);
      });

      if (this._subPerUnitTargetsSelector) {
        var perUnitSpans = scope.querySelectorAll(this._subPerUnitTargetsSelector);
        perUnitSpans.forEach((span) => {
          var subUnitPrice = parseInt(span.getAttribute('data-price'), 10);
          if (!subUnitPrice) return;
          span.textContent = this._format(Math.round(subUnitPrice * (1 - tieredRate) / this._unitDivisor));
        });
      }

      var additionalSavings = scope.querySelector('[data-element="sub-additional-savings"]');
      if (additionalSavings) {
        if (tieredRate > 0) {
          additionalSavings.removeAttribute('hidden');
        } else {
          additionalSavings.setAttribute('hidden', '');
        }
      }
    }

    _getQuantity() {
      if (!this._quantityInputSelector) return 1;
      var scope = this.closest('[data-section-type]') || document;
      var el = scope.querySelector(this._quantityInputSelector);
      if (!el) el = document.querySelector(this._quantityInputSelector);
      return el ? (parseInt(el.value, 10) || 1) : 1;
    }

    _getRate(quantity) {
      for (var i = 0; i < this._discounts.length; i++) {
        if (quantity >= this._discounts[i].minQty) return this._discounts[i].rate / 100;
      }
      return 0;
    }

    getDiscountedTotal(quantity) {
      var effectiveQty = Math.max(quantity, 1);
      var rate = this._getRate(effectiveQty);
      var unitPrice = this._price || parseInt(this.dataset.price, 10) || 0;
      return (Math.round(unitPrice * (1 - rate)) * effectiveQty) / 100;
    }

    _format(cents) {
      return (cents / 100).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '\u00a0€';
    }

    _render(quantity) {
      if (!this._price) return;
      var effectiveQuantity = Math.max(quantity, 1);
      var rate = this._getRate(effectiveQuantity);
      var baseTotal = this._price * effectiveQuantity;

      if (rate > 0) {
        var discounted = Math.round(baseTotal * (1 - rate));
        this.innerHTML =
          '<span class="regular-price">' + this._format(baseTotal) + '</span>' +
          '<span class="sale-price"> '   + this._format(discounted) + '</span>';
      } else {
        this.innerHTML = '<span class="sale-price">' + this._format(baseTotal) + '</span>';
      }
    }

    _updateTargets(quantity) {
      var effectiveQuantity = Math.max(quantity, 1);
      var rate = this._getRate(effectiveQuantity);
      var scope = this.closest('[data-section-type]') || document;
      var isSubscriptionCardScope = !!this.closest('[data-section-type="product-item-subscription"]');
      var isCrossSellScope = !!this.closest('[data-section-type="cross-sell-item"]');
      var spans = scope.querySelectorAll(this._updateTargetsSelector);

      spans.forEach((span) => {
        var prev = span.parentNode.querySelector('.dp-regular-price, .primary.text-subdued.line-through');
        if (prev) prev.remove();

        var unitPrice = parseInt(span.getAttribute('data-price'), 10);
        var subUnitPrice = parseInt(span.getAttribute('data-sub-price') || '', 10) || unitPrice;
        if (!unitPrice) return;

        var baseTotal = unitPrice * effectiveQuantity;

        if (rate > 0) {
          var discounted = Math.round(subUnitPrice * (1 - rate)) * effectiveQuantity;

          var strikeSpan = document.createElement('span');
          strikeSpan.className = 'regular-price dp-regular-price';
          strikeSpan.textContent = this._format(baseTotal);

          span.innerHTML = ' ' + this._format(discounted);

          if (isSubscriptionCardScope) {
            // Subscription cards: show discounted price first, then struck-through price.
            span.classList.remove('sale-price');
            strikeSpan.style.marginLeft = '6px';
            if (span.nextSibling) {
              span.parentNode.insertBefore(strikeSpan, span.nextSibling);
            } else {
              span.parentNode.appendChild(strikeSpan);
            }
          } else if (isCrossSellScope) {
            // Cross-sell: discounted price first (red), then struck-through (primary text-subdued line-through)
            span.parentNode.classList.add('red');
            strikeSpan.className = 'primary text-subdued line-through';
            if (span.nextSibling) {
              span.parentNode.insertBefore(strikeSpan, span.nextSibling);
            } else {
              span.parentNode.appendChild(strikeSpan);
            }
          } else {
            span.classList.add('sale-price');
            span.parentNode.insertBefore(strikeSpan, span);
          }

          var compareAtSpan = span.parentNode.querySelector('[data-element="compare-at-price"]');
          if (compareAtSpan) compareAtSpan.style.display = 'none';
        } else {
          span.classList.remove('sale-price');
          if (isCrossSellScope) span.parentNode.classList.remove('red');
          span.innerHTML = this._format(subUnitPrice * effectiveQuantity);

          var compareAtSpan = span.parentNode.querySelector('[data-element="compare-at-price"]');
          if (compareAtSpan) compareAtSpan.style.display = '';
        }
      });

      if (this._perUnitTargetsSelector) {
        var perUnitSpans = scope.querySelectorAll(this._perUnitTargetsSelector);
        perUnitSpans.forEach((span) => {
          var unitPrice = parseInt(span.getAttribute('data-price'), 10);
          if (!unitPrice) return;
          span.textContent = this._format(Math.round(unitPrice * (1 - rate) / this._unitDivisor));
        });
      }
    }
  }

  if (!customElements.get('degressive-price')) {
    customElements.define('degressive-price', DegressivePrice);
  }

})();
